export function wrapIndex(
    index: number,
    length: number,
): number {
    if (!Number.isSafeInteger(length) || length <= 0) {
        throw new RangeError(
            "Carousel length must be a positive integer",
        );
    }

    if (!Number.isSafeInteger(index)) {
        throw new RangeError(
            "Carousel index must be an integer",
        );
    }

    return ((index % length) + length) % length;
}
